/**
 * Stores recently viewed collection handles in localStorage.
 */
export class RecentlyViewedCollections {
  /** @static @constant {string} */
  static #STORAGE_KEY = 'viewedCollections:v2';
  /** @static @constant {number} */
  static #MAX_COLLECTIONS = 50;

  /**
   * @param {string | { handle: string }} collection
   */
  static addCollection(collection) {
    const handle = typeof collection === 'string' ? collection : collection?.handle;
    if (!handle) return;

    let viewed = this.getCollections();
    viewed = viewed.filter((h) => h !== handle);
    viewed.unshift(handle);
    viewed = viewed.slice(0, this.#MAX_COLLECTIONS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewed));
    } catch (err) {
      console.warn('[RecentlyViewedCollections] save failed:', err);
    }
  }

  /** @param {string} handle */
  static removeCollection(handle) {
    const viewed = this.getCollections().filter((h) => h !== handle);
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewed));
    } catch {}
  }

  static clearCollections() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /** @returns {string[]} handles, most recent first */
  static getCollections() {
    try {
      const raw = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return raw
        .map((item) => (typeof item === 'string' ? item : item?.handle))
        .filter((h) => typeof h === 'string' && h.length > 0);
    } catch {
      return [];
    }
  }
}